import { createAction, props } from '@ngrx/store';

export const saveLocationInt = createAction(
    '[AUTH] save location int info',
    props<{ value: any }>(),
);

export const clearLocationInt = createAction('[AUTH] clear location int info');
